let tempCounter = 0;
const buildTempId = () => `temp-interesado-${tempCounter++}`;

const cleanText = (value) => (typeof value === "string" ? value.trim() : value || "");

const parseNullableId = (value) => {
  if (value === null || value === undefined || value === "") return null;
  const parsed = Number(value);
  return Number.isNaN(parsed) ? null : parsed;
};

export const normalizeInteresado = (interesado = {}, fallbackId) => {
  const nombres = cleanText(interesado.nombres || interesado.nombre);
  const apellidos = cleanText(interesado.apellidos || interesado.apellido);
  const documento = cleanText(interesado.documento || interesado.documento_identidad);
  const telefono = cleanText(interesado.telefono || interesado.celular);
  const email = cleanText(interesado.email);
  const fuenteOrigen = cleanText(
    interesado.fuente_origen || interesado.fuente_origen_nombre || interesado.fuenteOrigen
  );
  const empresaOrigen = cleanText(
    interesado.empresa_referencia ||
      interesado.empresa_origen ||
      interesado.empresa_origen_nombre ||
      interesado.empresa ||
      interesado.centro
  );
  const estadoInteres = (interesado.estado_interes || interesado.estadoInteres || "nuevo").toLowerCase();
  const referidoNombre = [cleanText(interesado.referido_nombres), cleanText(interesado.referido_apellidos)]
    .filter(Boolean)
    .join(" ")
    .trim();

  return {
    id: interesado.id ?? fallbackId ?? buildTempId(),
    nombres,
    apellidos,
    nombreCompleto: [nombres, apellidos].filter(Boolean).join(" ").trim() || nombres || apellidos || cleanText(interesado.nombre),
    documento,
    telefono,
    email,
    fuenteOrigen,
    fuenteOrigenId: parseNullableId(interesado.fuente_origen_id),
    empresaOrigen,
    empresaOrigenId: parseNullableId(interesado.empresa_origen_id),
    estadoInteres,
    creadoEn: interesado.creado_en || interesado.created_at || interesado.creadoEn || null,
    updatedAt: interesado.updated_at || interesado.updatedAt || null,
    referidoPorId: parseNullableId(interesado.referido_por_id),
    referidoNombre,
    referidoDocumento: cleanText(interesado.referido_documento),
    referidoEstado: cleanText(interesado.referido_estado),
    transferido: Number(interesado.transferido) === 1,
    tieneMatricula: Number(interesado.tiene_matricula) === 1,
  };
};

const toNullable = (value) => {
  const cleaned = typeof value === "string" ? value.trim() : value;
  return cleaned === "" || cleaned === undefined ? null : cleaned;
};

const toUpperValue = (value) => (typeof value === "string" ? value.trim().toUpperCase() : value);

export const buildInteresadoPayload = (form) => ({
  nombres: toUpperValue(form.nombres || ""),
  apellidos: toUpperValue(toNullable(form.apellidos)),
  documento: toNullable(form.documento),
  telefono: (form.telefono || "").trim() || null,
  email: toNullable(form.email),
  fuente_origen_id: parseNullableId(form.fuente_origen_id),
  empresa_origen_id: parseNullableId(form.empresa_origen_id),
  referido_por_id: parseNullableId(form.referido_por_id),
  estado_interes: (form.estado_interes || form.estadoInteres || "nuevo").toLowerCase(),
  ...(form.fecha_registro ? { fecha_registro: form.fecha_registro } : {}),
});

export const estadoInteresLabel = (estado) => {
  switch ((estado || "").toLowerCase()) {
    case "interesado":
      return "Interesado";
    case "prematriculado":
      return "Pre-matriculado";
    case "matriculado":
      return "Matriculado";
    case "descartado":
      return "Descartado";
    default:
      return "Nuevo";
  }
};
